export default "__VITE_ASSET__a95cbb6a__"